var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "battery-store__wrapper" }, [
      _c("div", { staticClass: "css-grid battery-store__header" }, [
        _c("div", { staticClass: "battery-store__header-name" }, [
          _vm._v("Fuel Battery Partners")
        ])
      ]),
      _vm._v(" "),
      _c("div", [
        _c(
          "div",
          {
            staticClass:
              "battery-order-view__container battery-order-view__container--form"
          },
          [
            _c("div", { staticStyle: { padding: "30px" } }, [
              _c("p", [
                _vm._v(
                  "Fuel Medical Group is proud to offer access to high-quality, mercury-free batteries now directly through ReSound and Starkey. Our members can enjoy the reliability of Rayovac’s top-tier materials, a sturdy design and a higher capacity than standard mercury batteries, which translates to a longer shelf life and satisfied patients."
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Both ReSound and Starkey offer standard and private-label batteries. For more information on pricing, how to order and private labeling from each manufacturer, please see below."
                )
              ]),
              _vm._v(" "),
              _c("div", { staticStyle: { padding: "15px" } }, [
                _c("img", {
                  attrs: {
                    width: "250px",
                    src: "/images/battery-store/ReSound_logo.svg"
                  }
                })
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "ReSound offers Rayovac Proline Advanced batteries in the following four sizes: 675, 312, 13 and 10A. They offer 10 cards of six with a minimum order quantity of 10 cartons per order. The pricing starts at $0.21 per cell or $12.80 per carton. Private labeling is included upon request."
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Please see the following instructions below on how to order private-label batteries from ReSound:"
                )
              ]),
              _vm._v(" "),
              _c("ol", [
                _c("li", [
                  _vm._v(
                    "Submit the image, logo or specific colors you’d like to have on the label to your GN ReSound customer care rep."
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "Review the artwork for approval. Confirm your clinic name, address and phone number are correct."
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v("Upon approval, your order will be submitted.")
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "Please allow one to two days before you start ordering your private-label batteries."
                  )
                ]),
                _vm._v(" "),
                _c("li", [
                  _vm._v(
                    "Please call your GN ReSound customer care rep at 1-800-248-4327 when you place orders."
                  )
                ])
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Non private label batteries can be ordered online through your account at "
                ),
                _c("a", { attrs: { href: "mailto:pro.resound.com" } }, [
                  _vm._v("pro.resound.com")
                ]),
                _vm._v(".")
              ]),
              _vm._v(" "),
              _c("div", { staticStyle: { padding: "15px 0" } }, [
                _c("img", {
                  staticStyle: { width: "250px", height: "150px" },
                  attrs: { src: "/images/battery-store/starkey-logo.svg" }
                })
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Starkey offers Rayovac batteries for our members at $0.21 per cell or $12.60 per carton. They offer a six-pack, long tab in a 60-count and a cochlear option for $30, which is a 60-count."
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Custom private labeling is offered, but there is a one-time setup fee of $30. Creation of the label takes five business days. Alternative options are a blank label or a Starkey label."
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "Members have the choice to ship via UPS, choosing between Ground, 2nd day and Overnight, with varying pricing for shipping. Shipping is cut off daily at 1 p.m."
                )
              ]),
              _vm._v(" "),
              _c("p", [
                _vm._v(
                  "To order Rayovac batteries through Starkey, please call 1-800-328-8602 or email Bruce Himple at "
                ),
                _c(
                  "a",
                  { attrs: { href: "mailto:bruce_himple@starkey.com" } },
                  [_vm._v("bruce_himple@starkey.com")]
                ),
                _vm._v(".")
              ]),
              _vm._v(" "),
              _c("p", [
                _c("span", { staticStyle: { "font-size": "10px" } }, [
                  _vm._v(
                    "For all Rayovac batteries, all sizes come in new child-proof packaging as required by FDA Reese’s Law, effective 5/8/2024."
                  )
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "battery-store__footer" })
            ])
          ]
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }